import { FC, useMemo } from 'react';

import useSWR from 'swr';

import { CreateDistributionLinkButton } from './createDistributionLinkButton/CreateDistributionLinkButton';
import { DistributionLinkActionsColumn } from './distributionLinkTableColumns/DistributionLinkActionsColumn';
import { DistributionLinkActiveColumn } from './distributionLinkTableColumns/DistributionLinkActiveColumn';
import { DistributionLinkUrlColumn } from './distributionLinkTableColumns/DistributionLinkUrlColumn';

import css from './DistributionLinkPage.module.css';

import { distributionLinksService } from 'v2/api/distributionLinksService';
import { DataTable } from 'v2/components/dataTable/DataTable';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { TableColumn } from 'v2/types';
import { DistributionLinkModel } from 'v2/types/DistributionLinkModel';
import { formatNumber } from 'v2/utils';

export const DistributionLinkPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getDistributionLinks', distributionLinksService.getDistributionLinks);

  const columns: TableColumn<DistributionLinkModel>[] = useMemo(
    () => [
      {
        key: 'isActive',
        label: 'Active',
        style: { width: '5%' },
        render: (row) => <DistributionLinkActiveColumn distributionLink={row} />,
      },
      { id: 'key', key: 'key', label: 'Key', ellipsis: true, style: { width: '5%' } },
      {
        key: 'url',
        label: 'URL',
        style: { width: '40%' },
        render: (row) => <DistributionLinkUrlColumn distributionLink={row} />,
      },
      {
        key: 'totalUses',
        label: 'Total Uses',
        align: 'right',
        render: (row) => formatNumber(row.totalUses),
      },
      {
        key: 'maxUses',
        label: 'Max Uses',
        align: 'right',
        render: (row) => formatNumber(row.maxUses),
      },
      {
        key: 'actions',
        align: 'right',
        render: (row) => <DistributionLinkActionsColumn distributionLink={row} onRevalidate={mutate} />,
      },
    ],
    [mutate]
  );

  return (
    <PageLayout className={css.distributionLinkPage} overflow="hidden">
      <PageTitle action={<CreateDistributionLinkButton onSuccess={mutate} />}>Distribution Links Settings</PageTitle>

      {isLoading ? <Loader /> : <DataTable columns={columns} data={data} />}
    </PageLayout>
  );
};
